import { render, staticRenderFns } from "./GetMyTask.vue?vue&type=template&id=0206431d&"
import script from "./GetMyTask.vue?vue&type=script&lang=js&"
export * from "./GetMyTask.vue?vue&type=script&lang=js&"
import style0 from "./GetMyTask.vue?vue&type=style&index=0&id=0206431d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports